import {
  SET_DEFAULT_TEXTS,
  SET_MODAL_VISIBLE,
  USER_TEXTS_GENERATED,
  MODAL_CLOSED } from '../../action-types/ui/babyPage';

export const setDefaultBabyTexts = status => ({
  type: SET_DEFAULT_TEXTS,
  status,
});

export const setModalVisible = status => ({
  type: SET_MODAL_VISIBLE,
  status,
});

export const userTextsGenerated = status => ({
  type: USER_TEXTS_GENERATED,
  status,
});

export const setModalStatus = status => ({
  type: MODAL_CLOSED,
  status,
});




// WEBPACK FOOTER //
// ./src/redux/actions/ui/babyPage.js